import { API_V1 } from 'API/APIs/APIv1';
import { FunnelFunctionsLibrary } from 'features/admin/prompt-management/prompt-management.types';
import { FunnelTypes } from 'features/co-pilot/co-pilot.types';
import _ from 'lodash';
import Logger from 'logger';

export const getFunnelFunctionLibraries = async (funnelType: FunnelTypes | undefined) => {
  try {
    const response = await API_V1.get('/ai-builders/function-libraries', {
      params: { type: funnelType },
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting all funnel function libraries!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const createFunnelFunctionLibrary = async (libraryName: string, funnelType: FunnelTypes) => {
  try {
    const response = await API_V1.post('/ai-builders/function-libraries', {
      name: libraryName,
      type: funnelType,
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while creating a new funnel function library!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const updateFunnelFunctionLibrary = async (libraryId: string, libraryData: Partial<FunnelFunctionsLibrary>) => {
  try {
    const response = await API_V1.put(`/ai-builders/function-libraries/${libraryId}`, libraryData);

    return response.data;
  } catch (e) {
    Logger.trace('Error while updating funnel function library %s!', libraryId);
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const deleteFunnelFunctionLibrary = async (libraryId: string) => {
  try {
    const response = await API_V1.delete(`/ai-builders/function-libraries/${libraryId}`);

    return response.data ?? { success: true };
  } catch (e) {
    Logger.trace('Error while deleting funnel function library %s!', libraryId);
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
